import axios from 'axios'

class GovernoratesService {
  getGovernorates = (page, size, search) =>
    axios({
      url: 'governorates',
      method: 'GET',
      params: {
        page,
        take: size,
        ...(search ? { search } : {}),
      },
    })

  pullGovernorates = () =>
    axios({
      url: 'governorates/pull',
      method: 'GET',
    })
}

export default new GovernoratesService()

